module.exports = __webpack_public_path__ + "img/btn-share.cd277bee.gif";